import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { ButtonVariant, Colors, FlexBox } from '@brg/ui'
import { API, Endpoints } from '@brg/api'
import { LayoutConst, useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import { ButtonRow, ActionButton, CloseWrapper } from '../EnrollCourseModal/styles'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const Wrapper = styled(FlexBox)`
  width: 560px;
  background: #FEFEFE;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  position: relative;
  padding: 32px 40px 40px 40px;
  flex-flow: column;
  align-items: center;
  gap: 16px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 320px;
    padding: 32px 20px 24px;
  }
`;

export const Title = styled.div`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
  text-align: left;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const Description = styled.div`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  color: ${Colors.galBlack100};
  text-align: left;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    line-height: 18px;
  }
`

interface PracticModalProps {
  competitionId?: string
}

export const PracticModal: FC<PracticModalProps> = ({ competitionId = '' }) => {
  const modal = useModal()
  const { t } = useTranslation()
  const history = useHistory()

  const handleClose = () => {
    modal.hide()
  }

  const handleYes = async () => {
    modal.show(
      'send-project'
      , {
      id: competitionId,
      isPreRegistration: false,
      isAllowParticipants: false,
      // singleProjectSelection: isPaidWithForm,
      onClose: () => modal.hide(),
  })
  }

  return (
    <Wrapper>
      <CloseWrapper>
        <IconCloseMob onClick={handleClose} />
      </CloseWrapper>

      <Title>{t('modal.practic_modal.title')}</Title>
      <Description>
        {t('modal.practic_modal.subtitle')}
      </Description>

      <ButtonRow>
        <ActionButton width={228} variant={ButtonVariant.Hollow} onClick={handleClose}>
          {t('modal.practic_modal.buttons.no')}
        </ActionButton>
        <ActionButton width={228} variant={ButtonVariant.Filled} onClick={handleYes}>
          {t('modal.practic_modal.buttons.yes')}
        </ActionButton>
      </ButtonRow>
    </Wrapper>
  )
}
import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { ButtonVariant, Colors, FlexBox } from '@brg/ui'
import { API, Endpoints } from '@brg/api'
import { LayoutConst, useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import { ButtonRow, ActionButton, CloseWrapper } from '../EnrollCourseModal/styles'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const Wrapper = styled(FlexBox)`
  width: 560px;
  background: #FEFEFE;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  position: relative;
  padding: 32px 40px 40px 40px;
  flex-flow: column;
  align-items: center;
  gap: 16px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 320px;
    padding: 32px 20px 24px;
  }
`;

export const Title = styled.div`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
  text-align: left;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const Description = styled.div`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  color: ${Colors.galBlack100};
  text-align: left;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    line-height: 18px;
  }
`

interface PracticModalProps {
  competitionId?: string
}

export const PracticModal: FC<PracticModalProps> = ({ competitionId = '' }) => {
  const modal = useModal()
  const { t } = useTranslation()
  const history = useHistory()

  const handleClose = () => {
    modal.hide()
  }

  const handleYes = async () => {
    modal.show(
      'send-project'
      , {
      id: competitionId,
      isPreRegistration: false,
      isAllowParticipants: false,
      // singleProjectSelection: isPaidWithForm,
      onClose: () => modal.hide(),
  })
  }

  return (
    <Wrapper>
      <CloseWrapper>
        <IconCloseMob onClick={handleClose} />
      </CloseWrapper>

      <Title>{t('modal.practic_modal.title')}</Title>
      <Description>
        {t('modal.practic_modal.subtitle')}
      </Description>

      <ButtonRow>
        <ActionButton width={228} variant={ButtonVariant.Hollow} onClick={handleClose}>
          {t('modal.practic_modal.buttons.no')}
        </ActionButton>
        <ActionButton width={228} variant={ButtonVariant.Filled} onClick={handleYes}>
          {t('modal.practic_modal.buttons.yes')}
        </ActionButton>
      </ButtonRow>
    </Wrapper>
  )
}
